import { defineNuxtPlugin } from '#app';
import Bugsnag from '@bugsnag/js';
import type { Client } from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue'

// Provided imperatively via nuxtApp.provide() below, so declare the injected
// type here (it can no longer be inferred from a returned `provide` object).
// Optional because it's only provided when bugsnag is enabled.
declare module '#app' {
  interface NuxtApp {
    $bugsnag?: Client;
  }
}

export default defineNuxtPlugin((nuxtApp) => {

  const runtimeConfig = useRuntimeConfig();

  if(runtimeConfig.public.bugsnagEnabled) {

    const { currentUserId } = useWadAuth();
    const { isOnline } = useConnectivity();

    const bugsnagClient = Bugsnag.start({
      apiKey: runtimeConfig.public.bugsnagApiKey as string,
      appVersion: runtimeConfig.public.bugsnagAppVersion as string,
      plugins: [new BugsnagPluginVue()],
      releaseStage: runtimeConfig.public.wadEnvironment,
      onError: function (event) {
        // Don't report errors when offline - they're expected network failures. Uses the app's
        // connectivity state rather than navigator.onLine, which when stuck false dropped every
        // report of the session and hid this class of bug from Bugsnag entirely.
        if(!isOnline.value) return false;
        if(currentUserId.value) {
          event.setUser(currentUserId.value.toString());
        }
      }
    });

    const vueApp = nuxtApp.vueApp;
    const bugsnagVue = bugsnagClient.getPlugin('vue');

    if (bugsnagVue) {
      bugsnagVue.installVueErrorHandler(vueApp);
    }

    // Provide Bugsnag plugin globally
    nuxtApp.provide('bugsnag', bugsnagClient);
  }

});
